// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Alert,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import { Add, Edit, Delete, SupervisorAccount } from '@mui/icons-material';
// import { Formik, Form } from 'formik';
// import * as Yup from 'yup';
// import apiService from '../services/apiService';

// const AdminUsersPage = () => {
//   const [admins, setAdmins] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [openDialog, setOpenDialog] = useState(false);
//   const [editMode, setEditMode] = useState(false);
//   const [selectedAdmin, setSelectedAdmin] = useState(null);

//   useEffect(() => {
//     fetchAdmins();
//   }, []);

//   const fetchAdmins = async () => {
//     try {
//       setLoading(true);
//       const response = await apiService.getAdminUsers();

//       // Log the actual response to debug
//       console.log('API Response:', response);

//       if (response.success) {
//         setAdmins(response.data);
//       } else {
//         setError(response.message || 'Failed to load admin users');
//         loadMockData();
//       }
//     } catch (err) {
//       console.error('Admin users error:', err);
//       setError('Failed to load admin users');
//       loadMockData();
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadMockData = () => {
//     setAdmins([
//       {
//         id: '1',
//         name: 'Admin User',
//         email: 'admin@pushpa.com',
//         username: 'admin',
//         role: 'super_admin',
//         isActive: true,
//         createdAt: '2025-01-01',
//       },
//       {
//         id: '2',
//         name: 'Support Manager',
//         email: 'support@pushpa.com',
//         username: 'support',
//         role: 'admin',
//         isActive: true,
//         createdAt: '2025-01-05',
//       },
//     ]);
//   };

//   const handleAdd = () => {
//     setEditMode(false);
//     setSelectedAdmin(null);
//     setOpenDialog(true);
//   };

//   const handleEdit = (admin) => {
//     setEditMode(true);
//     setSelectedAdmin(admin);
//     setOpenDialog(true);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this admin user?')) {
//       return;
//     }

//     try {
//       const response = await apiService.deleteAdminUser(id);

//       if (response.success) {
//         alert('Admin user deleted successfully');
//         fetchAdmins();
//       } else {
//         alert(response.message || 'Failed to delete admin user');
//       }
//     } catch (err) {
//       alert('Failed to delete admin user');
//     }
//   };

//   const handleSubmit = async (values, { setSubmitting }) => {
//     try {
//       let response;
//       if (editMode) {
//         response = await apiService.updateAdminUser(selectedAdmin.id, values);
//       } else {
//         response = await apiService.addAdminUser(values);
//       }

//       if (response.success) {
//         alert(`Admin user ${editMode ? 'updated' : 'created'} successfully`);
//         setOpenDialog(false);
//         fetchAdmins();
//       } else {
//         alert(response.message || 'Operation failed');
//       }
//     } catch (err) {
//       alert('Operation failed');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const validationSchema = Yup.object({
//     name: Yup.string().required('Name is required'),
//     email: Yup.string().email('Invalid email').required('Email is required'),
//     username: Yup.string().required('Username is required'),
//     role: Yup.string().required('Role is required'),
//     ...(!editMode && {
//       password: Yup.string()
//         .required('Password is required')
//         .min(6, 'Password must be at least 6 characters'),
//     }),
//   });

//   const getRoleChip = (role) => {
//     const roleConfig = {
//       super_admin: { label: 'Super Admin', color: 'error' },
//       admin: { label: 'Admin', color: 'primary' },
//       support: { label: 'Support', color: 'info' },
//       taxi_attachment: { label: 'Taxi Attachment', color: 'success' },
//     };

//     const config = roleConfig[role] || roleConfig.admin;
//     return <Chip label={config.label} color={config.color} size="small" />;
//   };

//   const columns = [
//     {
//       field: 'name',
//       headerName: 'Name',
//       width: 200,
//       renderCell: (params) => (
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//           <SupervisorAccount color="primary" />
//           <Typography variant="body2" fontWeight={600}>
//             {params.row.name}
//           </Typography>
//         </Box>
//       ),
//     },
//     {
//       field: 'email',
//       headerName: 'Email',
//       width: 220,
//     },
//     {
//       field: 'username',
//       headerName: 'Username',
//       width: 150,
//     },
//     {
//       field: 'role',
//       headerName: 'Role',
//       width: 150,
//       renderCell: (params) => getRoleChip(params.row.role),
//     },
//     {
//       field: 'status',
//       headerName: 'Status',
//       width: 120,
//       renderCell: (params) => (
//         <Chip label="Active" color="success" size="small" />
//       ),
//     },
//     {
//       field: 'created_at',
//       headerName: 'Created At',
//       width: 180,
//       renderCell: (params) => {
//         if (!params.row.created_at) return '-';
//         return new Date(params.row.created_at).toLocaleString('en-US', {
//           year: 'numeric',
//           month: 'short',
//           day: 'numeric',
//           hour: '2-digit',
//           minute: '2-digit',
//         });
//       },
//     },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       sortable: false,
//       renderCell: (params) => (
//         <Box>
//           <IconButton size="small" onClick={() => handleEdit(params.row)}>
//             <Edit fontSize="small" />
//           </IconButton>
//           {params.row.role !== 'super_admin' && (
//             <IconButton size="small" color="error" onClick={() => handleDelete(params.row.id)}>
//               <Delete fontSize="small" />
//             </IconButton>
//           )}
//         </Box>
//       ),
//     },
//   ];

//   return (
//     <Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//         <Box>
//           <Typography variant="h4" fontWeight="bold" gutterBottom>
//             Admin Users
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Manage admin panel users and permissions
//           </Typography>
//         </Box>
//         <Button variant="contained" startIcon={<Add />} onClick={handleAdd}>
//           Add Admin User
//         </Button>
//       </Box>

//       {error && (
//         <Alert severity="warning" sx={{ mb: 3 }}>
//           {error} - Showing demo data
//         </Alert>
//       )}

//       <Card>
//         <CardContent>
//           <DataGrid
//             rows={admins}
//             columns={columns}
//             pageSize={10}
//             rowsPerPageOptions={[10, 25, 50]}
//             disableSelectionOnClick
//             autoHeight
//             loading={loading}
//             sx={{
//               '& .MuiDataGrid-cell:focus': {
//                 outline: 'none',
//               },
//             }}
//           />
//         </CardContent>
//       </Card>

//       {/* Add/Edit Admin Dialog */}
//       <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>{editMode ? 'Edit' : 'Add'} Admin User</DialogTitle>
//         <Formik
//           initialValues={{
//             name: selectedAdmin?.name || '',
//             email: selectedAdmin?.email || '',
//             username: selectedAdmin?.username || '',
//             role: selectedAdmin?.role || 'admin',
//             password: '',
//             isActive: selectedAdmin?.isActive ?? true,
//           }}
//           validationSchema={validationSchema}
//           onSubmit={handleSubmit}
//         >
//           {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
//             <Form>
//               <DialogContent>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       name="name"
//                       label="Full Name"
//                       value={values.name}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.name && Boolean(errors.name)}
//                       helperText={touched.name && errors.name}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       name="email"
//                       label="Email"
//                       type="email"
//                       value={values.email}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.email && Boolean(errors.email)}
//                       helperText={touched.email && errors.email}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       name="username"
//                       label="Username"
//                       value={values.username}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.username && Boolean(errors.username)}
//                       helperText={touched.username && errors.username}
//                     />
//                   </Grid>
//                   {!editMode && (
//                     <Grid item xs={12}>
//                       <TextField
//                         fullWidth
//                         name="password"
//                         label="Password"
//                         type="password"
//                         value={values.password}
//                         onChange={handleChange}
//                         onBlur={handleBlur}
//                         error={touched.password && Boolean(errors.password)}
//                         helperText={touched.password && errors.password}
//                       />
//                     </Grid>
//                   )}
//                   <Grid item xs={12}>
//                     <FormControl fullWidth>
//                       <InputLabel>Role</InputLabel>
//                       <Select
//                         name="role"
//                         value={values.role}
//                         onChange={handleChange}
//                         label="Role"
//                       >
//                         <MenuItem value="super_admin">Super Admin</MenuItem>
//                         <MenuItem value="admin">Admin</MenuItem>
//                         <MenuItem value="support">Support</MenuItem>
//                         <MenuItem value="taxi_attachment">Taxi Attachment</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </DialogContent>
//               <DialogActions>
//                 <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
//                 <Button type="submit" variant="contained" disabled={isSubmitting}>
//                   {editMode ? 'Update' : 'Create'}
//                 </Button>
//               </DialogActions>
//             </Form>
//           )}
//         </Formik>
//       </Dialog>
//     </Box>
//   );
// };

// export default AdminUsersPage;


import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Add, Edit, Delete, SupervisorAccount, People } from '@mui/icons-material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import apiService from '../services/apiService';

const AdminUsersPage = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    try {
      setLoading(true);
      const response = await apiService.getAdminUsers();

      console.log('API Response:', response);

      if (response.success) {
        // Map the response to ensure status field exists
        const adminsWithStatus = response.data.map(admin => ({
          ...admin,
          status: admin.status || 'active',
          createdAt: admin.created_at || admin.createdAt,
        }));
        setAdmins(adminsWithStatus);
      } else {
        setError(response.message || 'Failed to load admin users');
        loadMockData();
      }
    } catch (err) {
      console.error('Admin users error:', err);
      setError('Failed to load admin users');
      loadMockData();
    } finally {
      setLoading(false);
    }
  };

  const loadMockData = () => {
    setAdmins([
      {
        id: '1',
        name: 'Admin User',
        email: 'admin@pushpa.com',
        username: 'admin',
        role: 'super_admin',
        status: 'active',
        created_at: '2025-01-01T00:00:00.000Z',
      },
      {
        id: '2',
        name: 'Support Manager',
        email: 'support@pushpa.com',
        username: 'support',
        role: 'support',
        status: 'active',
        created_at: '2025-01-05T00:00:00.000Z',
      },
      {
        id: '3',
        name: 'Taxi Attach User',
        email: 'taxi@pushpa.com',
        username: 'taxi',
        role: 'taxi_attachment',
        status: 'active',
        created_at: '2025-01-10T00:00:00.000Z',
      },
    ]);
  };

  // Calculate role counts
  const getRoleCounts = () => {
    const counts = {
      total: admins.length,
      super_admin: 0,
      admin: 0,
      support: 0,
      taxi_attachment: 0,
    };

    admins.forEach(admin => {
      if (admin.role === 'super_admin') counts.super_admin++;
      else if (admin.role === 'admin') counts.admin++;
      else if (admin.role === 'support') counts.support++;
      else if (admin.role === 'taxi_attachment') counts.taxi_attachment++;
    });

    return counts;
  };

  const roleCounts = getRoleCounts();

  const handleAdd = () => {
    setEditMode(false);
    setSelectedAdmin(null);
    setOpenDialog(true);
  };

  const handleEdit = (admin) => {
    setEditMode(true);
    setSelectedAdmin(admin);
    setOpenDialog(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this admin user?')) {
      return;
    }

    try {
      const response = await apiService.deleteAdminUser(id);

      if (response.success) {
        alert('Admin user deleted successfully');
        fetchAdmins();
      } else {
        alert(response.message || 'Failed to delete admin user');
      }
    } catch (err) {
      alert('Failed to delete admin user');
    }
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      let response;
      if (editMode) {
        response = await apiService.updateAdminUser(selectedAdmin.id, values);
      } else {
        response = await apiService.addAdminUser(values);
      }

      if (response.success) {
        alert(`Admin user ${editMode ? 'updated' : 'created'} successfully`);
        setOpenDialog(false);
        fetchAdmins();
      } else {
        alert(response.message || 'Operation failed');
      }
    } catch (err) {
      alert('Operation failed');
    } finally {
      setSubmitting(false);
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    username: Yup.string().required('Username is required'),
    role: Yup.string().required('Role is required'),
    ...(!editMode && {
      password: Yup.string()
        .required('Password is required')
        .min(6, 'Password must be at least 6 characters'),
    }),
  });

  const getRoleChip = (role) => {
    const roleConfig = {
      super_admin: { label: 'Super Admin', color: 'error' },
      admin: { label: 'Admin', color: 'primary' },
      support: { label: 'Support', color: 'info' },
      taxi_attachment: { label: 'Taxi Attachment', color: 'success' },
    };

    const config = roleConfig[role] || roleConfig.admin;
    return <Chip label={config.label} color={config.color} size="small" />;
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 200,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SupervisorAccount color="primary" />
          <Typography variant="body2" fontWeight={600}>
            {params.row.name}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 220,
    },
    {
      field: 'username',
      headerName: 'Username',
      width: 150,
    },
    {
      field: 'role',
      headerName: 'Role',
      width: 150,
      renderCell: (params) => getRoleChip(params.row.role),
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 120,
      renderCell: (params) => (
        <Chip 
          label={params.row.status === 'active' ? 'Active' : 'Inactive'} 
          color={params.row.status === 'active' ? 'success' : 'default'} 
          size="small" 
        />
      ),
    },
    {
      field: 'created_at',
      headerName: 'Created At',
      width: 180,
      renderCell: (params) => {
        if (!params.row.created_at) return '-';
        return new Date(params.row.created_at).toLocaleString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        });
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton size="small" onClick={() => handleEdit(params.row)}>
            <Edit fontSize="small" />
          </IconButton>
          {params.row.role !== 'super_admin' && (
            <IconButton size="small" color="error" onClick={() => handleDelete(params.row.id)}>
              <Delete fontSize="small" />
            </IconButton>
          )}
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Admin Users
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Manage admin panel users and permissions
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<Add />} onClick={handleAdd}>
          Add Admin User
        </Button>
      </Box>

      {/* Role Summary Cards */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={2.4}>
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              bgcolor: '#f5f5f5',
            }}
          >
            <Box>
              <Typography variant="caption" color="text.secondary">
                Total
              </Typography>
              <Typography variant="h5" fontWeight="bold">
                {roleCounts.total}
              </Typography>
            </Box>
            <People sx={{ fontSize: 40, color: 'primary.main' }} />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              bgcolor: '#ffebee',
            }}
          >
            <Box>
              <Typography variant="caption" color="text.secondary">
                Super Admin
              </Typography>
              <Typography variant="h5" fontWeight="bold" color="error">
                {roleCounts.super_admin}
              </Typography>
            </Box>
            <SupervisorAccount sx={{ fontSize: 40, color: 'error.main' }} />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              bgcolor: '#e3f2fd',
            }}
          >
            <Box>
              <Typography variant="caption" color="text.secondary">
                Admin
              </Typography>
              <Typography variant="h5" fontWeight="bold" color="primary">
                {roleCounts.admin}
              </Typography>
            </Box>
            <SupervisorAccount sx={{ fontSize: 40, color: 'primary.main' }} />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              bgcolor: '#e8eaf6',
            }}
          >
            <Box>
              <Typography variant="caption" color="text.secondary">
                Support
              </Typography>
              <Typography variant="h5" fontWeight="bold" color="info">
                {roleCounts.support}
              </Typography>
            </Box>
            <SupervisorAccount sx={{ fontSize: 40, color: 'info.main' }} />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              bgcolor: '#e8f5e9',
            }}
          >
            <Box>
              <Typography variant="caption" color="text.secondary">
                Taxi Attachment
              </Typography>
              <Typography variant="h5" fontWeight="bold" color="success">
                {roleCounts.taxi_attachment}
              </Typography>
            </Box>
            <SupervisorAccount sx={{ fontSize: 40, color: 'success.main' }} />
          </Paper>
        </Grid>
      </Grid>

      {error && (
        <Alert severity="warning" sx={{ mb: 3 }}>
          {error} - Showing demo data
        </Alert>
      )}

      <Card>
        <CardContent>
          <DataGrid
            rows={admins}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 25, 50]}
            disableSelectionOnClick
            autoHeight
            loading={loading}
            sx={{
              '& .MuiDataGrid-cell:focus': {
                outline: 'none',
              },
            }}
          />
        </CardContent>
      </Card>

      {/* Add/Edit Admin Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editMode ? 'Edit' : 'Add'} Admin User</DialogTitle>
        <Formik
          initialValues={{
            name: selectedAdmin?.name || '',
            email: selectedAdmin?.email || '',
            username: selectedAdmin?.username || '',
            role: selectedAdmin?.role || 'admin',
            password: '',
            status: selectedAdmin?.status || 'active',
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
            <Form>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="name"
                      label="Full Name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="email"
                      label="Email"
                      type="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.email && Boolean(errors.email)}
                      helperText={touched.email && errors.email}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="username"
                      label="Username"
                      value={values.username}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.username && Boolean(errors.username)}
                      helperText={touched.username && errors.username}
                    />
                  </Grid>
                  {!editMode && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.password && Boolean(errors.password)}
                        helperText={touched.password && errors.password}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>Role</InputLabel>
                      <Select
                        name="role"
                        value={values.role}
                        onChange={handleChange}
                        label="Role"
                      >
                        <MenuItem value="super_admin">Super Admin</MenuItem>
                        <MenuItem value="admin">Admin</MenuItem>
                        <MenuItem value="support">Support</MenuItem>
                        <MenuItem value="taxi_attachment">Taxi Attachment</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>Status</InputLabel>
                      <Select
                        name="status"
                        value={values.status}
                        onChange={handleChange}
                        label="Status"
                      >
                        <MenuItem value="active">Active</MenuItem>
                        <MenuItem value="inactive">Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                <Button type="submit" variant="contained" disabled={isSubmitting}>
                  {editMode ? 'Update' : 'Create'}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </Box>
  );
};

export default AdminUsersPage;